{
  "boxes1": [
    {
      "title": "Fewer absence leaves",
      "text": "you will reduce the costs of absence leaves and lower productivity",
      "image": {
        "url": "/images/box_1.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Talent retention",
      "text": "you will reduce employee turnover",
      "image": {
        "url": "/images/box_2.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Prevent occupational burnout",
      "text": "you will create employee-friendly work environment and a tried and tested support system",
      "image": {
        "url": "/images/box_3.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Reaching goals",
      "text": "you will influence the team effectiveness by raising their work satisfaction level",
      "image": {
        "url": "/images/box_4.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    }
  ],
  "boxes10": [
    {
      "title": "Subscription module",
      "text": "An intuitive and convenient way to manage the benefits made available by your company. \n    Make benefits from all external suppliers (such as a sports card, medical care or group insurance) available to your \n    employees or selected groups of employees.",
      "image": {
        "url": "/icons/icon-8.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Organisation Structure",
      "text": "Optimise the coordination of HR processes and expand the capabilities of other MyBenefit modules. Get access to all employee data in one place, boost HR team efficiency and save valuable time.",
      "image": {
        "url": "/icons/icon-9.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "e-Signature",
      "text": "Streamline the process of obtaining employees’ consents to deducting payments for benefits from their \n    salaries by using the e-signature functionality. Automate the document workflow in your company.",
      "image": {
        "url": "/icons/icon-10.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Employee application forms",
      "text": "Quick and simple applications for allowances, holiday benefits, or nursery and kindergarten subsidies, \n    based on criteria that are relevant to you. Choose comfort and ecology – say goodbye to paper and digitize your \n    company’s employee requests!",
      "image": {
        "url": "/icons/icon-11.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Absences",
      "text": "Easy submission and processing of leave requests, remote work requests and more. Automate the collection of absence data to reduce paperwork and plan team work more effectively when employees are on leave or sick leave.",
      "image": {
        "url": "/icons/icon-12.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Remuneration Module",
      "text": "Create a clear remuneration system and prepare your company for upcoming legal changes. Get support in building job architecture and defining career paths, reduce the pay gap and increase your company’s competitiveness as an employer.",
      "image": {
        "url": "/icons/icon-16.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ],
  "boxes11": [
    {
      "title": "Cafeteria module",
      "text": "Use the working assets or the In-House Social Benefits Fund assets and award points to employees that \n    they can redeem for vouchers to any stores of their choice, vouchers to cultural events, tourist events or sports events. \n    Take care of your employees’ well-being by giving them the freedom to choose the exact benefits they need.",
      "image": {
        "url": "/icons/icon-13.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Knowledge Base",
      "text": "Efficient management of company documents, such as instructions, presentations or articles, as well as the organisation of folders and subfolders and content publishing. Give employees constant access to company knowledge, keep materials up to date, streamline sharing between teams and support the onboarding process.",
      "image": {
        "url": "/icons/icon-14.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Total Reward Statement",
      "text": "Now you can not only show your team the number of points in the cafeteria, but also benefits, such as subsidised lunch, \n    language courses, “fruit days”. Show your employees a list of their individual benefits and make them aware of non-wage \n    benefits in the organisation.",
      "image": {
        "url": "/icons/icon-15.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Reward system",
      "text": "Motivating employees has never been so easy. Reward your employees on an ongoing basis by topping up their \n    points balance in the Cafeteria. Provide managers with budgets for instant and individual recognition of engagement. \n    Grant awards to mark special occasions such as anniversaries, birthdays or holidays at the company.",
      "image": {
        "url": "/icons/icon-17.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "News",
      "text": "An easy-to-use tool for publishing important company announcements, filtering recipients and  creating themed groups for employees. Get an effective communication channel with your team, reduce the number of emails and give employees a space for discussion and knowledge sharing.",
      "image": {
        "url": "/icons/icon-18.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ],
  "boxes12": [
    {
      "title": "Better health and well-being of employees",
      "text": "Employers have an impact on the physical shape and healthy habits of their teams",
      "image": {
        "url": "/images/boxes/Pic-8.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Lower costs of absenteeism",
      "text": "An investment into health and activity means fewer sick leaves and absence leaves",
      "image": {
        "url": "/images/boxes/Pic-9.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Higher engagement",
      "text": "Taking care of physical well-being translates into the employees’ effectiveness",
      "image": {
        "url": "/images/boxes/Pic-10.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Lower stress and negative effects of stress",
      "text": "Prevent occupational burnout and strengthen your team’s mental condition by motivating them to be active",
      "image": {
        "url": "/images/boxes/Pic-11.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "An image of a caring and supportive employer",
      "text": "Build a friendly work environment and attract unique talents",
      "image": {
        "url": "/images/boxes/Pic-12.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    }
  ],
  "boxes13": [
    {
      "title": "Advisory services and after-sale service",
      "text": "We will help you choose the best offer of sports cards for you and your team. We will carry out the implementation process \n    and adapt the financing method in a flexible manner",
      "image": {
        "url": "/images/boxes/Pic-13.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "A good portion of expert knowledge",
      "text": "It is our mission to support people in their journey towards an active and healthy lifestyle We provide \n    user-friendly education on Instagram and Facebook, among others, as well as via dedicated mailings, newsletters and challenges for users.",
      "image": {
        "url": "/images/boxes/Pic-14.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "International Visits",
      "text": "The only sports card that allows your employees to participate in activities in Poland and abroad. The largest database of facilities on the market makes this benefit useful every day, on vacation, and during business trips.",
      "image": {
        "url": "/images/boxes/Pic-15.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Knowledge and Motivation",
      "text": "Online training sessions, videos for beginners, and educational, motivational, and inspirational content created by experts support employees in building an active lifestyle.",
      "image": {
        "url": "/images/boxes/Pic-16.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Knowledge-driven experience",
      "text": "We have researched the needs of companies and employees for more than 23 years and our findings have enabled us to create \n    the most sought-after sport card.",
      "image": {
        "url": "/images/boxes/Pic-17.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Full user support",
      "text": "We provide a dedicated infoline that is open 7 days a week to ensure full information and service for your \n    organisation so that you don’t need to be an intermediary.",
      "image": {
        "url": "/images/boxes/Pic-18.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    }
  ],
  "boxes14": [
    {
      "id": 1,
      "title": "Health",
      "text": "Take care of effective prevention in your team by getting fast access to telemedicine consultations with a doctor, \n    preventive health screenings without a referral, as well as consultations with a trainer or a dietician.",
      "image": {
        "url": "/images/boxes/Pic-19.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "id": 2,
      "title": "Personal development",
      "text": "Provide development tools, such as language courses, webinars and training courses, original programmes, \n    access to e-books and audiobooks as well as support from experts.",
      "image": {
        "url": "/images/boxes/Pic-20.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "id": 3,
      "title": "Mental well-being",
      "text": "Build a strong and resilient team thanks to access to regular consultations with a psychologist, \n    a calming app and mindfulness courses.",
      "image": {
        "url": "/images/boxes/Pic-21.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "id": 4,
      "title": "Nutrition",
      "text": "A portion of health for your team – starting from consultations with a dietician and a trainer to useful courses and \n    training programmes up to a personalised diet creator.",
      "image": {
        "url": "/images/boxes/Pic-22.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ],
  "boxes15": [
    {
      "title": "Absenteeism and absence leaves in response to stress",
      "text": "You will lower the number of absence leaves by providing services that support mental- and physical health of your employees",
      "image": {
        "url": "/images/boxes/Pic-23.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Employee turnover",
      "text": "In understanding your team’s needs and supporting their personal- and professional development,\n    you will make them think less often about changing jobs",
      "image": {
        "url": "/images/boxes/Pic-24.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Lower engagement and “quiet quitting”",
      "text": "Employees who feel taken care of put in more effort and implement the organisation’s goals",
      "image": {
        "url": "/images/boxes/Pic-25.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Symptoms that lead to burnout",
      "text": "By supporting your team’s resilience, you counteract the long-term stress effects",
      "image": {
        "url": "/images/boxes/Pic-26.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    }
  ],
  "boxes3": [
    {
      "title": "New! Well-being Concierge",
      "text": "Let us create and implement an effective well-being strategy for you and trust an expert who will measure the well-being level, \n    choose the right solutions and provide support at every step of the way",
      "image": {
        "url": "/images/screen_4.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "New! Wellbeing Score",
      "text": "Well-being has become a measurable ratio for the employers Measure the well-being level and start acting in key areas \n    that require changes.",
      "image": {
        "url": "/images/screen_2.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "Recognized products",
      "text": "Support physical-, mental- and financial well-being with well-known and sought-after products: \n    MultiSport, Multi.Life and MyBenefit.",
      "image": {
        "url": "/images/screen_3.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "Webinars and workshops",
      "text": "Adapt the topics of expert training courses, in the classroom or online, to your team’s needs.",
      "image": {
        "url": "/images/screen_1.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "Expert support",
      "text": "Provide your employees with access to regular consultations with a psychologist, a dietician and a personal trainer so \n    that they can reduce their stress levels, regain balance and make a step towards improving their health.",
      "image": {
        "url": "/images/screen_5.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    }
  ],
  "boxes4": [
    {
      "text": "Easily accessible expert knowledge – training programmes, training course library, consultations with a psychologist, \n    a dietician and a trainer, and access to services supporting personal goals"
    },
    {
      "text": "Regular reports – HR dashboards will give you insight into the current well-being level in your company and the employees’ \n    needs to which you can respond on a regular basis"
    },
    {
      "text": "Full control over well-being solutions via a single platform"
    }
  ],
  "boxes5": [
    {
      "title": "FOR THE COMPANY",
      "text": "A platform that allows you to examine, monitor and improve the well-being levels in your company",
      "image": {
        "url": "/images/head-1.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "FOR EMPLOYEES",
      "text": "An assistant in your journey to achieving a healthy lifestyle, well-being and your personal goals",
      "image": {
        "url": "/images/head-2.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    }
  ],
  "boxes6": [
    {
      "title": "Comprehensive support for four areas of well-being",
      "text": "Support one area"
    },
    {
      "title": "Customisation and flexible scope",
      "text": "Lack of services customisation"
    },
    {
      "title": "Access to a dozen of supporting services and applications",
      "text": "No access to partner services and applications"
    },
    {
      "title": "The ability to add complementary products: MultiSport, MyBenefit",
      "text": "Access to one product"
    }
  ],
  "boxes7": [
    {
      "text": "<span>23.8 million</span> days a year – this is the number of days Poles miss each year due to mental health issues and \n    behaviour disturbances, including as a result of reactions to stress",
      "subtext": "Report on sick leave absences by the Social Insurance Institution in 2022."
    },
    {
      "text": "<span>72% of employees in Europe</span> are the so-called “quiet-quitters” who do not engage in their work",
      "subtext": "2023 State of the Global Workplace Report"
    }
  ],
  "boxes8": [
    {
      "title": "Sports enthusiast",
      "text": "Embark on an adventure with sports and get into perfect shape with small goals.",
      "image": {
        "url": "/images/boxes/box-10.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Metabolism and body weight control",
      "text": "Get the perfect shape and healthy body full of energy by tailoring your diet to your own needs.",
      "image": {
        "url": "/images/boxes/box-11.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Good health and quality of life – longevity",
      "text": "Start to live a healthy and quality life by getting a great night’s sleep, taking care of your energy level, good appearance or sex life.",
      "image": {
        "url": "/images/boxes/box-12.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Finances",
      "text": "Take control of your household budget and finances by learning how to invest in a smart way, and multiply your capital.",
      "image": {
        "url": "/images/boxes/box-13.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Personal development",
      "text": "Overcome your limitations and develop in any way thanks to simple habits.",
      "image": {
        "url": "/images/boxes/box-14.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Stress and resilience building",
      "text": "Lower your stress levels and take care of your mental support with effective self-care strategies.",
      "image": {
        "url": "/images/boxes/box-15.jpg"
      }
    },
    {
      "title": "Mindfulness and Slow life",
      "text": "Slow down and enjoy life, experience gratitude and build healthy habits.",
      "image": {
        "url": "/images/boxes/Pic-27.jpg"
      }
    }
  ],
  "boxes9": [
    {
      "title": "Time savings",
      "text": "You will simplify the work of the entire team and shorten the necessary formalities to the absolute minimum",
      "image": {
        "url": "/icons/frame-1.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Effective motivating",
      "text": "You will make your team more engaged thanks to modern benefits, gamification and friendly rewarding",
      "image": {
        "url": "/icons/frame-2.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Financial well-being",
      "text": "You will influence the employees’ sense of safety and satisfaction thanks to a flexible cafeteria system",
      "image": {
        "url": "/icons/frame-3.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "A strong organisation",
      "text": "You will deliver state-of-art tools for effective work",
      "image": {
        "url": "/icons/frame-4.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ]
}